<template>
  <b-modal ref="modal-settings" size="lg" id="modal-settings" :title="$t('settings.title')">
    <div v-if="saving == true" class="text-center">
      <LoadingAnimation />
    </div>
    <div v-else>
      <b-row class="settingsTopbar">
        <b-col>
          {{ venueTitle }}
        </b-col>
        <b-col>
          <a style="cursor: pointer" @click="logout">
            <i18n path="settings.logout">
              <template v-slot:image>
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m16.333 8-1.292 1.41L16.489 11H9v2h7.49l-1.45 1.58L16.334 16 20 12l-3.667-4zM5.778 6.556H12V5H5.778C4.8 5 4 5.7 4 6.556v10.888C4 18.3 4.8 19 5.778 19H12v-1.556H5.778V6.556z"
                    fill="#0CBA4A" fill-rule="nonzero" />
                </svg>
              </template>
              <template v-slot:username>
                {{ getUser.username }}
              </template>
            </i18n>
          </a>
        </b-col>
      </b-row>

      <div class="spacer l"></div>

      <b-row>
        <b-col>
          <h4>{{ $t('settings.glasperbottle') }}</h4>
        </b-col>
      </b-row>

      <b-row v-if="getBottleSizes && getBottleSizes.length > 0" class="glasSettings">
        <b-row>
          <b-col cols="3">{{ $t('settings.bottles') }}</b-col>
          <b-col cols="2">{{ $t('settings.glassamount') }}</b-col>
          <b-col cols="1"></b-col>
          <b-col cols="3" v-if="getBottleSizes.length > 1">{{ $t('settings.bottles') }}</b-col>
          <b-col cols="2" v-if="getBottleSizes.length > 1">{{ $t('settings.glassamount') }}</b-col>
        </b-row>

        <div class="glasSettingsEntry" v-for="(element, index) in getBottleSizes" :key="index">
          <b-row>
            <b-col cols="6">{{ element.attributes.amount }}</b-col>
            <b-col cols="5">
              <b-form-input type="number" v-model="selectedGlassSize[element.id]" min="1"></b-form-input>
            </b-col>
          </b-row>
        </div>
      </b-row>

      <div class="spacer l"></div>

      <b-row>
        <b-col>
          <h4>{{ $t('general.supplier') }}</h4>
        </b-col>
      </b-row>

      <b-row class="supplierRow">
        <b-col>
          <label>{{ $t('general.name') }}</label>
        </b-col>
        <b-col>
          <label>{{ $t('general.zipcode') }}</label>
        </b-col>
        <b-col>
          <label>{{ $t('general.city') }}</label>
        </b-col>
        <b-col>
          <label>{{ $t('general.email') }}</label>
        </b-col>
        <b-col>
        </b-col>
      </b-row>

      <div v-for="supplier in filterNotDeletedWineSuppliers" :key="supplier.id">
        <b-row v-if="!supplier.attributes.isGeneral" class="supplierRow">
          <b-col>
            <input v-model="supplier.attributes.title">
          </b-col>
          <b-col>
            <input v-if="supplier.attributes.address !== null" v-model="supplier.attributes.address.zip">
          </b-col>
          <b-col>
            <input v-if="supplier.attributes.address !== null" v-model="supplier.attributes.address.city">
          </b-col>
          <b-col>
            <input v-model="supplier.attributes.email">
          </b-col>
          <b-col>
            <button class="iconButton delete" @click="askToFlagDeleteSupplier(supplier)">
            </button>
          </b-col>
        </b-row>
      </div>

      <b-row class="bezugsquelleRow">
        <b-col>
          <button class="iconButton add" @click="addEmptySupplier()">
            {{ $t('settings.addsupplier') }}
          </button>
        </b-col>
      </b-row>

      <div class="spacer l"></div>

      <b-row>
        <b-col>
          <h4> {{ $t('general.currencys') }}</h4>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <b-dropdown :text="selectedCurrency.shortname + ' - ' + selectedCurrency.name">
            <b-dropdown-item v-for="option in getCurrencies" :key="option.attributes.name" :value="option"
              @click="currencyChanged(option)">
              {{ option.attributes.shortname }} - {{ option.attributes.name }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>

      <div class="spacer l"></div>

      <b-row>
        <b-col>
          <h4> {{ $t('settings.outboundBlackList') }}</h4>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-textarea v-model="outboundBlacklistText" rows="10" :placeholder="$t('settings.outboundBlackListPlaceholder')"></b-form-textarea>
        </b-col>
      </b-row>

      <b-alert v-model="showInfoAlert.show" variant="warning" dismissible>
        {{ showInfoAlert.message }}
      </b-alert>

      <b-alert v-model="showRedAlert.show" variant="danger" dismissible>
        {{ showRedAlert.message }}
      </b-alert>

    </div>

    <template class="poolinqModalFooter" #modal-footer="{ cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="danger" @click="cancel()">
        {{ $t('general.buttons.cancel') }}
      </b-button>
      <b-button size="sm" variant="success" @click="saveSettings()" :disabled="saving">
        {{ $t('general.buttons.save') }}
      </b-button>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import DataService from '@/services/StrapiService'
import LoadingAnimation from '@/components/LoadingAnimation.vue'
import * as Utils from '@/utils/functions'
import Tracking from '@/utils/tracking'

const CREATE_WINE_SUPPLIER = "create"
const DELETE_WINE_SUPPLIER = "delete"
const SAMMEL_LIEFERANT = "Sammellieferant"

export default {
  name: 'SettingsModal',
  components: {
    LoadingAnimation
  },
  mounted() {
    const app = this
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if (modalId == "modal-settings") {

        Tracking.trackEvent(
          Tracking.CATEGORY_VENUE,
          Tracking.ACTION_SHOW_SETTINGS
        )

        app.resetMessages()
        // Fetch the latest venue from the API first, so the blacklist (and
        // other settings) reflect changes made elsewhere (e.g. the
        // ReceiptMatcher "add to ignore list" action).
        await app.refreshVenue()
        app.getWineSuppliers()
        app.getGlassAmounts()
        app.getCurrency()
        app.getOutboundBlacklist()
      }
    });
  },
  data() {
    return {
      wineSuppliers: [],
      outboundBlacklist: [],
      showRedAlert: {
        show: false,
        message: "",
      },
      showInfoAlert: {
        show: false,
        message: ""
      },
      selectedGlassSize: {},
      saving: false,
      selectedCurrency: {
        name: this.$t("settings.selectCurrency"),
        shortname: "",
      },
      selectedCurrencyId: 0,
    }
  },
methods: {
    /**
     * Fetches the latest venue object from the API and updates the store,
     * so the settings always reflect the current state (e.g. the blacklist
     * may have been changed in the ReceiptMatcher).
     */
    async refreshVenue() {
      try {
        const response = await DataService.getVenueDetail()
        this.$store.commit('updateVenue', response['data'].data)
      } catch (err) {
        console.log(err)
      }
    },
    getCurrency() {
      if (this.getVenue.attributes.currency) {
        this.selectedCurrency = this.getVenue.attributes.currency.data.attributes
        this.selectedCurrencyId = this.getVenue.attributes.currency.data.id
      }
    },
    getOutboundBlacklist() {
      if (this.getVenue.attributes.outboundBlacklist) {
        this.outboundBlacklist = this.getVenue.attributes.outboundBlacklist
      }
    },
    resetMessages() {
      this.showRedAlert.message = ""
      this.showRedAlert.show = false
      this.showInfoAlert.message = ""
      this.showInfoAlert.show = false
    },
    getWineSuppliers() {
      if (this.getVenue) {
        this.wineSuppliers = JSON.parse(JSON.stringify(this.getVenue.attributes.wineSuppliers.data))
      }
    },
    refreshWineSuppliers() {
      this.wineSuppliers = JSON.parse(JSON.stringify(this.wineSuppliers))
    },
    /**
     * Adds an empty row of WineSupplier to edit
     */
    addEmptySupplier() {
      if (this.wineSuppliers) {
        this.wineSuppliers.push({
          id: null,
          attributes: {
            title: null,
            email: null,
            address: { zip: null, city: null },
            venues: { data: [this.getVenue.id] },
          },
          [CREATE_WINE_SUPPLIER]: true,
        })
      }
    },
    /**
     * We need to show a confirmation dialog before we flag a WineSupplier for delete.
     * This is because we need to inform the user that all PurchasePrices of this WineSupplier will be moved to Sammellieferant.
     * @param supplier 
     */
    askToFlagDeleteSupplier(supplier) {
      if (supplier.attributes.title === SAMMEL_LIEFERANT) {
        this.showRedAlert.message = "Sammellieferant kann nicht gelöscht werden"
        this.showRedAlert.show = true
        return
      }
      this.$bvModal.msgBoxConfirm(this.$t('settings.confirmDeleteSupplier', { supplier: supplier.attributes.title }), {
        title: this.$t('general.buttons.confirmDelete'),
        okVariant: 'danger',
        okTitle: this.$t('general.buttons.delete'),
        cancelTitle: this.$t('general.buttons.cancel'),
        modalClass: 'supplier-delete-confirm-modal'
      }).then((confirmed) => {
        if (confirmed) {
          this.flagDeleteSupplier(supplier)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    /**
     * Flag WineSupplier for delete. Count all VenueWines that will be moved to Sammellieferant and show info 
     */
    flagDeleteSupplier(supplier) {

      supplier[DELETE_WINE_SUPPLIER] = true

      const deleteWineSuppliers = this.wineSuppliers.filter(ws => ((DELETE_WINE_SUPPLIER in ws) && !(CREATE_WINE_SUPPLIER in ws)))
      const deleteWineSuppliersIds = deleteWineSuppliers.map(ws => ws.id)
      const deleteWineSuppliersTitles = deleteWineSuppliers.map(ws => ws.attributes.title)

      if (deleteWineSuppliers.length == 0) {
        this.refreshWineSuppliers()
        return
      }
      DataService.countVenueWinesOfWineSuppliers(deleteWineSuppliersIds).then((response) => {
        const affectedVenueWines = response['data'].data
        if (affectedVenueWines > 0) {
          this.showInfoAlert.message = 'Beim Löschen von ' + deleteWineSuppliersTitles.join() + ' werden die Preise von ' + response['data'].data + ' Weinen zum Sammellieferant übertragen'
          this.showInfoAlert.show = true
        }
        this.refreshWineSuppliers()
      }).catch((err) => {
        console.log(err)
      })

    },
    /**
     * Looks for newly added wine suppliers and creates them
     * Looks for delete-flagged WineSuppliers 
     * Looks for PurchasePrices of deleted WineSuppliers and adds them to Sammellieferant
     * Deletes WineSupplier
     */
    async saveSettings() {
      this.saving = true
      const newWineSuppliers = this.wineSuppliers.filter(ws => ((CREATE_WINE_SUPPLIER in ws) && !(DELETE_WINE_SUPPLIER in ws)))
      const otherWineSuppliers = this.wineSuppliers.filter(ws => (!(CREATE_WINE_SUPPLIER in ws) && !(DELETE_WINE_SUPPLIER in ws)))
      var createValid = true;
      var changeValid = true;
      var errorWasFound = false

      for (let i = 0; i < otherWineSuppliers.length; i++) {
        const otherWineSupplier = otherWineSuppliers[i]
        if (otherWineSupplier.attributes.title != 'Sammellieferant' &&
          (otherWineSupplier.attributes.title == null)) {
          changeValid = false
          break
        }
      }
      if (!changeValid) {
        var alertobjectUpdate = {
          text: this.$t('settings.saveSupplierError'),
          variant: 'danger'
        }
        this.$store.commit('setAlertText', alertobjectUpdate)
        errorWasFound = true
        this.saving = false
        return
      }

      if (otherWineSuppliers.length > 0) {
        Tracking.trackEvent(
          Tracking.CATEGORY_VENUE,
          Tracking.ACTION_EDIT_SUPPLIER
        )
      }

      for (let i = 0; i < otherWineSuppliers.length; i++) {
        const otherWineSupplier = otherWineSuppliers[i]
        await DataService.updateWineSupplier(otherWineSupplier.id, otherWineSupplier).then(() => {
        }).catch((err) => {
          var alertobject = {
            text: this.$t('settings.updateSupplierError'),
            variant: 'danger'
          }
          this.$store.commit('setAlertText', alertobject)
          errorWasFound = true
          console.log(err)
        })
      }


      for (let i = 0; i < newWineSuppliers.length; i++) {
        const newWineSupplier = newWineSuppliers[i]
        if (!(newWineSupplier.attributes.title)) {
          createValid = false
          break
        }
      }

      if (!createValid) {
        var alertobjectValid = {
          text: this.$t('settings.saveSupplierError'),
          variant: 'danger'
        }
        this.$store.commit('setAlertText', alertobjectValid)
        errorWasFound = true
        this.saving = false
        return
      }

      if (newWineSuppliers.length > 0) {
        Tracking.trackEvent(
          Tracking.CATEGORY_VENUE,
          Tracking.ACTION_CREATE_SUPPLIER
        )
      }

      for (let i = 0; i < newWineSuppliers.length; i++) {
        const newWineSupplier = newWineSuppliers[i]
        await DataService.createWineSupplier(newWineSupplier).then(() => {
        }).catch((err) => {
          var alertobject = {
            text: 'Es gab einen Fehler beim Erstellen. Bitte Eingaben überprüfen!',
            variant: 'danger'
          }
          this.$store.commit('setAlertText', alertobject)
          console.log(err)
          errorWasFound = true
        })
      }

      await DataService.getVenueDetail().then((response) => {
        this.$store.commit('updateVenue', response['data'].data)
      }).catch((err) => {
        console.log(err)
      })

      const venue = Utils.deepCopyObject(this.getVenue)


      /**
       *  DELETE WINE-SUPPLIER:
       */
      const deleteWineSuppliers = this.wineSuppliers.filter(ws => ((DELETE_WINE_SUPPLIER in ws) && !(CREATE_WINE_SUPPLIER in ws)))

      if (deleteWineSuppliers.length > 0) {
        Tracking.trackEvent(
          Tracking.CATEGORY_VENUE,
          Tracking.ACTION_DELETE_SUPPLIER
        )
      }

      for (const deleteWineSupplier of deleteWineSuppliers) {
        await DataService.deleteWineSupplier(deleteWineSupplier.id, venue.id).then(() => {
          venue.attributes.wineSuppliers.data = venue.attributes.wineSuppliers.data.filter(ws => ws.id !== deleteWineSupplier.id)
        }).catch((err) => {
          console.log(err)
        })
      }

      /**
       *  SET GLASS SIZES:
       */
      var glassSizes = []
      for (const keyBottleSizeId in this.selectedGlassSize) {
        var newGlassSizeObject = {
          bottleSizeId: Number(keyBottleSizeId),
          amount: this.selectedGlassSize[keyBottleSizeId]
        }
        if (this.selectedGlassSize[keyBottleSizeId] < 1) {
          var alertobject = {
            text: 'Die Anzahl kleiner als 1 bei Gläsern pro Flasche ist nicht erlaubt',
            variant: 'danger'
          }
          this.$store.commit('setAlertText', alertobject)
          delete this.selectedGlassSize.keyBottleSizeId
          errorWasFound = true
        } else {
          glassSizes.push(newGlassSizeObject)
        }

      }
      
      // Save selected currency to venue
      venue.attributes.currency = this.selectedCurrencyId

      // Save selected glass sizes to venue
      venue.attributes.glassAmountPerBottle = glassSizes

      // Save selected outbound blacklist to venue
      venue.attributes.outboundBlacklist = this.outboundBlacklist

      //delete unnecessary attributes
      delete venue.attributes.playlists
      delete venue.attributes.smartLists
      delete venue.attributes.reports
      delete venue.attributes.wineries
      delete venue.attributes.wineSuppliers

      await DataService.updateVenue(venue.id, venue).then((response) => {
        this.$store.commit('updateVenue', response['data'].data)
        this.getWineSuppliers()
      }).catch((err) => {
        errorWasFound = true
        console.log(err)
      })

      this.$store.commit('reloadWineSuppliers')
      this.resetMessages()
      this.saving = false
      if (!errorWasFound) {

        Tracking.trackEvent(
          Tracking.CATEGORY_VENUE,
          Tracking.ACTION_SAVE_SETTINGS
        )

        this.$refs["modal-settings"].hide();
      }
    },
    logout() {
      Tracking.trackEvent(
        Tracking.CATEGORY_USER,
        Tracking.ACTION_LOGOUT
      )

      this.$router.push('/login')
      this.$store.dispatch('logout')
      this.$refs["modal-settings"].hide();
    },
    getGlassAmounts() {
      var glassSizesArray = this.getVenue.attributes.glassAmountPerBottle
      if (glassSizesArray != null) {
        for (var i = 0; i < glassSizesArray.length; i++) {
          this.selectedGlassSize[glassSizesArray[i].bottleSizeId] = glassSizesArray[i].amount
        }
      }
    },
    currencyChanged(option) {
      this.selectedCurrency = option.attributes;
      this.selectedCurrencyId = option.id
      var venue = this.getVenue
      venue.attributes.currency.data = option
      this.$store.commit('updateVenue', venue)
    }
  },
  computed: {
    venueTitle: function () {
      return this.getVenue.attributes != null ? this.getVenue.attributes.title : ''
    },
    filterNotDeletedWineSuppliers() {
      return this.wineSuppliers.filter(ws => !(DELETE_WINE_SUPPLIER in ws))
    },
    outboundBlacklistText: {
      get() {
        if (Array.isArray(this.outboundBlacklist)) {
          return this.outboundBlacklist.join('\n')
        }
        return this.outboundBlacklist ? String(this.outboundBlacklist) : ''
      },
      set(value) {
        this.outboundBlacklist = value.split('\n').map(l => l.trim()).filter(l => l.length > 0)
      }
    },
    ...mapGetters(['getUser', 'getVenue', 'getBottleSizes', 'getCurrencies'])
  }
}
</script>